'use client';

import { __assign } from '../../../_virtual/_tslib.js';
import React__default, { memo, useContext, useState, useRef, useEffect } from 'react';
import { SearchSectionWrapper, InputGroup, Icon, InputContent, CustomTreeSelect, ActionGroup, TextButton, SearchIconWrap } from './SearchSection.css.js';
import { SearchBarContext } from '../../context/reducer.js';
import Button from '../../../Button/index.js';
import { IconSearch } from '../../../icons/index.js';
import { ACTIONS } from '../../context/actions.js';
import SearchInput from '../SearchInput/index.js';
import { DEFAULT_SEARCH_BAR_OPTIONS, SEARCH_INPUT_QUERY_STRING } from '../../constants.js';
import { getiOSVersion } from '../../../Utils/helpers.js';
import { colors } from '../../../Colors/index.js';
import Locations from '../Locations/index.js';
import useMediaQuery from '../../../hooks/useMediaQuery.js';
import 'react-dom';
import '../../../hooks/useMakeSearchable/types.js';
import '../../../Utils/constants.js';
import '../../../services/resumes/types.js';

var SearchSection = function (params) {
    var _a = useContext(SearchBarContext), props = _a.props, state = _a.state, dispatch = _a.dispatch, t = _a.t, search = _a.search;
    var isMountedDropdown = params.isMountedDropdown;
    var searchBarOptions = props.searchBarOptions, isMobile = props.isMobile, pageName = props.pageName;
    var isShow = state.isShow, keyword = state.keyword;
    var mergedSearchBarOptions = __assign(__assign({}, DEFAULT_SEARCH_BAR_OPTIONS), searchBarOptions);
    var _b = mergedSearchBarOptions.isHomepage, isHomepage = _b === void 0 ? false : _b;
    var _c = useState(true), isSupportAnim = _c[0], setSupportAnim = _c[1];
    var inputContentRef = useRef(null);
    var searchSectionWrapperRef = useRef(null);
    var matcher = useMediaQuery(!isHomepage ? '(max-width: 1023px)' : '(max-width: 767px)');
    var matcherMobile = useMediaQuery('(max-width: 767px)');
    var handleClickSearchIcon = function () {
        var _a;
        if (!inputContentRef.current) {
            return;
        }
        var inputElement = (_a = inputContentRef.current) === null || _a === void 0 ? void 0 : _a.querySelector(SEARCH_INPUT_QUERY_STRING);
        inputElement && inputElement.focus();
    };
    var onClickCancel = function () {
        dispatch({
            type: ACTIONS.CLOSE_DROP_DOWN
        });
    };
    var onClickSearch = function () {
        search();
    };
    useEffect(function () {
        var iOSVersion = getiOSVersion();
        setSupportAnim(iOSVersion === -2 || iOSVersion >= 16);
    }, []);
    return (React__default.createElement(SearchSectionWrapper, { "data-cname": 'seachSection', isMobile: isMobile, isHomepage: isHomepage, isShow: isShow, pageName: pageName, isMountedDropdown: isMountedDropdown, ref: searchSectionWrapperRef, isSupportAnim: isSupportAnim },
        React__default.createElement(InputGroup, { "data-cname": 'InputGroup', isMobile: isMobile, isHomepage: isHomepage, isShow: isShow },
            React__default.createElement(Icon, { className: 'sb-searchIcon', isHaveKeyword: keyword !== '', isShow: isShow, isMobile: isMobile, pageName: pageName, isHomePage: isHomepage, onClick: handleClickSearchIcon },
                React__default.createElement(IconSearch, { fill: colors.grey[20] })),
            React__default.createElement(InputContent, { ref: inputContentRef },
                React__default.createElement(SearchInput, null))),
        React__default.createElement(CustomTreeSelect, { isShow: isShow, isHomePage: isHomepage },
            React__default.createElement(Locations, null)),
        React__default.createElement(ActionGroup, { isShow: !matcher || isShow, isHomepage: isHomepage, isMobile: matcherMobile },
            React__default.createElement(Button, { className: 'search__button', type: 'primary', onClick: onClickSearch, "aria-label": t('Search') },
                React__default.createElement(TextButton, { isShow: isShow, isHomepage: isHomepage }, t('Search')),
                React__default.createElement(SearchIconWrap, { isShow: isShow, isHomepage: isHomepage },
                    React__default.createElement(IconSearch, { width: 20, height: 20, fill: colors.primary[100] })))),
        React__default.createElement(ActionGroup, { isShow: isMobile && isMountedDropdown && isShow },
            React__default.createElement(Button, { className: 'cancel__button', type: 'info', onClick: onClickCancel }, t('Cancel')))));
};
var SearchSection$1 = memo(SearchSection);

export { SearchSection$1 as default };
//# sourceMappingURL=index.js.map
